import { addSeconds, formatISO } from 'date-fns';

import { localDate } from '@iconik-io/core/src/date/format';
import type { SearchCriteriaRangeFilterSchema } from '@iconik-io/iconik-api/src/services/search';

/**
 * Adds 1 second to the right boundary. Used for preparing API requests for case where date picker
 * has -1 second for the internal representation, basically to prevent showing two days as selected when
 * only one day was clicked.
 * E.g. for UI the range should be 2021-03-24T00:00:00+01:00;2021-03-24T23:59:59+01:00
 * to show that the only one date is selected specifically.
 * While for API it should be 2021-03-24T00:00:00+01:00;2021-03-25T00:00:00+01:00 so it will return
 * everything up to the next day and we won't miss data from the last second.
 * @param dateRange
 */
export const addOneSecondToRightBoundary = (
  dateRange: SearchCriteriaRangeFilterSchema | undefined,
): string | undefined => {
  if (!dateRange) {
    return undefined;
  }
  const { min, max } = dateRange;
  return [
    formatISO(localDate(min)),
    formatISO(addSeconds(localDate(max), 1)),
  ].join(';');
};

export const addOneSecondToRightBoundaryString = (
  dateRange: string | undefined,
): string | undefined => {
  if (!dateRange) {
    return undefined;
  }
  const rangeValues = dateRange.split(';');
  if (rangeValues.length !== 2) {
    return dateRange;
  }
  const [from, to] = rangeValues;
  return [
    formatISO(localDate(from)),
    formatISO(addSeconds(localDate(to), 1)),
  ].join(';');
};
